<div class="justify-center px-[60px] py-[30px]" isOpen="true">
  <!-- <ion-content> -->
    <div class="flex flex-col items-center gap-[10px]">
      <ark-lib-icon-name name="success"></ark-lib-icon-name>
      <div>
        <h3 *ngIf="adminDelete" class="text-center">{{ adminDeleteText }}</h3>
        <h3 *ngIf="!adminDelete" class="text-center">Your account has been deleted</h3>
      </div>
    </div>
  <!-- </ion-content> -->
</div>